import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const userBoardSettingsRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-board-settings',
	path: '/jira/people/:accountId/boards/:boardId/settings/:config',
	query: ['from-backlog?'],
};
